import React from 'react'

import moment from 'moment'

import { getHumanizedShortDuration, TypeFormats } from 'utils/format'

export const TooltipPoint = ({ point, durationPoints, metric = '' }) => {
  const isServiceDeflection = metric === 'serviceDeflection'

  const getHumanizationFunc = () => {
    if (isServiceDeflection) {
      return TypeFormats.PERCENT
    }
    if (durationPoints) {
      return getHumanizedShortDuration
    }
    return TypeFormats.RAW_HUMANIZED
  }

  return (
    <span className="highcharts-tooltip-label">
      <p className="highcharts-tooltip-label-key">
        {moment.utc(new Date(point.key)).format('MM/DD/YY')}
      </p>
      <p>{getHumanizationFunc()(point.y)}</p>
    </span>
  )
}

export default TooltipPoint
